<template>
  <div v-if="props.ratings" class="product-rating flex items-center">
    <svg-icon name="star-filled" class="size-4 text-yellow-50" />
    <p>{{ props.ratings }}</p>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  ratings?: string
}

const props = defineProps<Props>()
</script>
